import React, { useContext, useState } from "react";
import { Button, Tab } from "@mui/material";
import Box from "@mui/material/Box";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import TanseedAssociateddetails from "../../tanseed-module/tanseed-startups-page/TanseedAssociateddetails";
import { useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DataContext from "../../../context/DataContext";
import CustomAssocaiateFormDetails from "./CustomAssocaiateFormDetails";

const CustomFormDetails = ({ name, path, route,showpdf }) => {
  const { startupId, configId } = useParams();
  const { navigator } = useContext(DataContext);
  // debugger
  let startupIds;
  if (startupId !== null) {
    startupIds = atob(startupId);
  }
  let configIds ;
  if (configId !== null) {
    configIds = atob(configId);
  }
  const [value, setValue] = useState("1");

  return (
    <div className="scsthub-div form_div chart">
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <TabPanel value="1">
            <CustomAssocaiateFormDetails
              route={route}
              name={name}
              path={path}
              startupIds={startupIds}
              configIds={configIds}
              showpdf={showpdf}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
};

export default CustomFormDetails;